/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  Signer,
  utils,
  BigNumberish,
  Contract,
  ContractFactory,
  Overrides,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { OldMGear, OldMGearInterface } from "../OldMGear";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IMineablePunks",
        name: "_mineablePunks",
        type: "address",
      },
      {
        internalType: "contract IMineableWords",
        name: "_mineableWords",
        type: "address",
      },
      {
        internalType: "contract IRenderer",
        name: "_renderer",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "normal",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "solid",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "noteworthy",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    stateMutability: "payable",
    type: "fallback",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "mgear",
        type: "uint256",
      },
    ],
    name: "getMGearName",
    outputs: [
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "mgear",
        type: "uint256",
      },
    ],
    name: "getMajorType",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "mgear",
        type: "uint256",
      },
    ],
    name: "getMajorValue",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "mgear",
        type: "uint256",
      },
    ],
    name: "getMinorType1",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "mgear",
        type: "uint256",
      },
    ],
    name: "getMinorType2",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "mgear",
        type: "uint256",
      },
    ],
    name: "getMinorValue1",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "mgear",
        type: "uint256",
      },
    ],
    name: "getMinorValue2",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "hashed",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "mpunk",
        type: "uint256",
      },
    ],
    name: "getTransmutationRarity",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    name: "inscribed",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "mineablePunks",
    outputs: [
      {
        internalType: "contract IMineablePunks",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "mineableWords",
    outputs: [
      {
        internalType: "contract IMineableWords",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint96",
        name: "nonce",
        type: "uint96",
      },
      {
        internalType: "uint8",
        name: "rarity",
        type: "uint8",
      },
      {
        internalType: "uint16",
        name: "mwordIndex",
        type: "uint16",
      },
      {
        internalType: "uint8",
        name: "nameFormat",
        type: "uint8",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "mpunkRolls",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "rarityToDifficulties",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "rarityToTiers",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "rarityToUpgradeRoll",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "uint16",
        name: "mwordIndex",
        type: "uint16",
      },
      {
        internalType: "uint8",
        name: "nameFormat",
        type: "uint8",
      },
    ],
    name: "rename",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "mgear",
        type: "uint256",
      },
    ],
    name: "renderData",
    outputs: [
      {
        internalType: "string",
        name: "data",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renderer",
    outputs: [
      {
        internalType: "contract IRenderer",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "statIdToStatName",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "tierToStatBase",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "tokenIdToMGear",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenOfOwnerByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "mpunk",
        type: "uint256",
      },
      {
        internalType: "uint16",
        name: "mwordIndex",
        type: "uint16",
      },
      {
        internalType: "uint8",
        name: "nameFormat",
        type: "uint8",
      },
    ],
    name: "transmute",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "transmuted",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "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";

export class OldMGear__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    _mineablePunks: string,
    _mineableWords: string,
    _renderer: string,
    normal: BigNumberish,
    solid: BigNumberish,
    noteworthy: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<OldMGear> {
    return super.deploy(
      _mineablePunks,
      _mineableWords,
      _renderer,
      normal,
      solid,
      noteworthy,
      overrides || {}
    ) as Promise<OldMGear>;
  }
  getDeployTransaction(
    _mineablePunks: string,
    _mineableWords: string,
    _renderer: string,
    normal: BigNumberish,
    solid: BigNumberish,
    noteworthy: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _mineablePunks,
      _mineableWords,
      _renderer,
      normal,
      solid,
      noteworthy,
      overrides || {}
    );
  }
  attach(address: string): OldMGear {
    return super.attach(address) as OldMGear;
  }
  connect(signer: Signer): OldMGear__factory {
    return super.connect(signer) as OldMGear__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): OldMGearInterface {
    return new utils.Interface(_abi) as OldMGearInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): OldMGear {
    return new Contract(address, _abi, signerOrProvider) as OldMGear;
  }
}
